// var text = `PBEC We Came Your Eyes

// Nama Pasien

// No. MR

// TTL

// :

// Agama .

// Alamat

// No. Hp

// Sph

// R

// OPTIK PBEC

// JI. Soekarno Hatta NO. 236 Pekanbaru Telp. (0761) 7875191

// L/P

// No. Bon :

// Nota Pembayaran

// Cyl

// Axis

// Add

// PD

// MPD

// PV

// Prisma

// Ket

// Rincian :

// Frame

// Lensa

// Discount

// Rp Rp

// Rp

// Rp

// Rp

// Terbilang

// Total

// DP+

// Sisa

// Pekanbaru,

// Petugas

// Apabila dalam jangka waktu 30 hari Kaca mata tidak diambil uang DP tidak dapat Dikembalikan kecuali ada perjanjian

// We Care Your Eyes`;

////console.log(text);

////console.log(text);
var draft = {
	title:'RESEP OPTIK',
	subtitle:'No....../20..',
	arr1: [
		{label:'Nama Pasien',value:''},
		{label:'Tanggal Lahir',value:''},
		{label:'Jenis Kelamin',value:''},
		{label:'No. RM',value:''},
	],
	arr2: [
		{label:'Agama',value:''},
		{label:'Alamat',value:''},
		{label:'Nomor HP',value:''},
		{label:'Nomor Rawat',value:''},
	],
	arr3: [
		{label:'Frame Abcdefgh',value:'Rp         ___'},
		{label:'Lensa Abcdefgh',value:'Rp         ___'},
		{label:'Diskon',value:'Rp         ___'},
	],
	arr4: [
		{label:'Terbilang',value:''},
	],
	arr5: [
		{label:'Total',value:'Rp         ___'},
		{label:'DP*',value:'Rp         ___'},
		{label:'Sisa',value:'Rp         ___'},
	],
	p1:`* Apabila dalam jangka waktu 30 hari Kaca mata tidak diambil uang DP tidak dapat Dikembalikan kecuali ada perjanjian`
};
var sign = `

Pekanbaru,<tgl>
Petugas




( <nama_petugas> )`;
import {
    headerImage
} from './headerImage.js';
import { labelValueFormatter } from './helper.js';
let arr1 = labelValueFormatter(draft.arr1,80);
let arr2 = labelValueFormatter(draft.arr2,90);
let arr3 = labelValueFormatter(draft.arr3,180);
let arr4 = labelValueFormatter(draft.arr4,80);
let arr5 = labelValueFormatter(draft.arr5,80);
export const docContent = [
	{
        image: headerImage,
        width: 529
	},
	{
        text: draft.title,
        style: 'title'
	},
	{
        // text: draft.subtitle,
        text:'',
        style: 'subtitle'
	},
	{
		columns: [
			[...arr1],[...arr2]
		]
	},
	{
        text: '',
        style: 'gap'
	},
	{
		table: {
			widths: ['auto',40,40,40,40,40,40,40,40,'*'],
			body: [
				['', 'Sph', 'Cyl','Axis', 'Add', 'PD','MPD', 'PV', 'Prisma','Ket'],
				['L', '', '','', '', '','', '', '',''],
				['R', '', '','', '', '','', '', '',''],
			]
		}
	},
	{
        text: '',
        style: 'gap'
	},
	...arr3,
	{
        text: '',
        style: 'gap'
	},
	{
		columns: [
			[...arr4],[...arr5]
		]
	},
	{
		columns: [
			{
				style: 'sign',
				text: ''
			},
			{
				style: 'sign',
				text: sign
			}
		]
	},
	{
		columns: [
			{
				style: 'paragraph',
				text: draft.p1
			},
			{
				style: 'paragraph',
				text: ''
			}
		]
	}
];

////console.log(docContent);